import axios from 'axios';

import cfac22 from '../cfac22';

export function getVoucherTemplate(uId, voucherId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(`${cfac22('API_HOST_V2')}/voucherTemplate/${voucherId}`, {
        headers: { 'Full-Url': window.location.href }, withCredentials: true
      }).
      then((result) => {
        //console.log("RESULT_VOUCHER: ", result);
        resolve(result.data.result);
      }).
      catch((error) => {
        //console.log("ERROR_VOUCHER: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
